<div style="padding: 10px;">
    <img src="{{imagePath}}" alt="Image" width="100%" height="100%">
</div>